// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2P-Th","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3mF9U","obliqueLine":"membershipbadge_obliqueLine__8_trN"};